class ClientService {
    constructor($http, authenticationService, globalConstants) {
        this.$http = $http;
        this.token = authenticationService.getToken();
        this.$http.defaults.headers.common.Authorization = 'Bearer ' + this.token;
        this.globalConstants = globalConstants;
    }

    getAll(query) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/clients',
            params: query
        });
    }

    get(id) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/clients/' + id
        });
    }

    delete(id) {
        return this.$http({
            method: 'DELETE',
            url: this.globalConstants.ApiBaseUrl + '/api/clients/' + id
        });
    }

    add(client) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/clients',
            data: client
        });
    }

    update(client) {
        client.clientTrainers = [];
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/clients',
            data: client
        });
    }

    assignTrainer(clientTrainer) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl +'/api/clients/assigntrainer',
            data: clientTrainer
        });
    }

    unassignTrainer(clientTrainer) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/clients/unassigntrainer',
            data: clientTrainer
        });
    }
}

export default ClientService;


// WEBPACK FOOTER //
// ./src/js/services/client.service.js